import styled from 'styled-components';

// This ensures the "RequiredDependencyMessage" component
// takes all the space of the cells
export default styled.div`
  table td {
    position: relative;
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestLines/BaseRequestLinesTable/TableContainer.js